<template>
  <div class="detail-container">
    <breadcrumb :list="breadList"></breadcrumb>

    <div class="pending" v-if="list && (list[0] && list[0].studentList.length < 1) && list[1] && list[1].studentList.length < 1">
      <img src="../../assets/image/pending-search.png" alt="">
      <p>抱歉，查询不到相关信息</p>
    </div>

    <div v-else>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="合格证信息" name="1" v-if="list && list[1] && list[1].studentList.length > 0">
          <approval :list="list[1].studentList"></approval>
        </el-tab-pane>
        <el-tab-pane label="结业证信息" name="2" v-if="list && list[0] && list[0].studentList.length > 0">
          <wind-up :list="list[0].studentList"></wind-up>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Approval from './components/approval'
import WindUp from './components/windUp'
import Breadcrumb from '@/components/breadcrumb'
import { queryCertificate } from '@/api/certificate'
export default {
  name: 'Detail',
  components: {
    Approval,
    WindUp,
    Breadcrumb
  },
  data() {
    return {
      breadList: [
        { label: '证书查询', path: '/certificate' },
        { label: '证书详情', path: '/certificateDetail' }
      ],
      activeName: '1',
      list: []
    }
  },
  mounted() {
    this.getCertificate()
  },
  methods: {
    getCertificate() {
      const form = JSON.parse(sessionStorage.getItem('form'))
      queryCertificate(form).then(res => {
        const { code, data } = res
        if (code === 0) {
          this.list = data
          if (this.list[1].studentList.length > 0) {
            this.activeName = '1'
          } else {
            this.activeName = '2'
          }
        }
      })
    },
    handleClick() {

    }
  }
}
</script>

<style lang="scss" scoped>
.detail-container {
  width: 1300px;
  margin: 40px auto 0;
  margin-bottom: 40px;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
  padding-bottom: 120px;
  .breadcrumb {
    width: 100%;
  }
  .pending {
    margin-top: 80px;
    text-align: center;
    p {
      color: #999;
      font-size: 16px;
      font-weight: 500;
      margin-top: 30px;
    }
  }
  ::v-deep .el-tabs {
    padding: 20px 60px;
    .el-tabs__nav-wrap::after {
      background-color: rgba(8, 93, 200, .35);
    }
    .el-tabs__active-bar {
      // width: 140px !important;
      height: 4px;
      background-color: #FF4E4E;
    }
    .el-tabs__nav {
      width: 320px;
      display: flex;
    }
    .el-tabs__item {
      width: 140px;
      color: #666;
      font-size: 18px;
      font-weight: bold;
      padding: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      &::before {
        content: '·';
        display: inline-block;
        font-size: 28px;
        color: #666;
        line-height: 70px;
      }
    }
    .el-tabs__item.is-active {
      color: #333;
      font-size: 20px;
      width: 140px;
      text-align: center;
      &::before {
        color: #D00D0D;
      }
    }
  }
}
</style>
